interface Step {
  id: number;
  title: string;
  description: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="pt-8 pb-12 px-8">
      <div className="flex space-x-4 w-full">
        {steps.map((step, index) => (
          <div
            key={step.id}
            className="flex flex-1 h-1.5 rounded-full overflow-hidden transition-all duration-300"
          >
            {index + 1 < currentStep ? (
              <>
                <div className="h-full w-1/2 bg-black dark:bg-white transition-all duration-300" />
                <div className="h-full w-1/2 bg-black dark:bg-white transition-all duration-300" />
              </>
            ) : index + 1 === currentStep ? (
              <>
                <div className="h-full w-1/2 bg-black dark:bg-white transition-all duration-300" />
                <div className="h-full w-1/2 bg-gray-300 dark:bg-zinc-700 transition-all duration-300" />
              </>
            ) : (
              <>
                <div className="h-full w-1/2 bg-gray-300 dark:bg-zinc-700 transition-all duration-300" />
                <div className="h-full w-1/2 bg-gray-300 dark:bg-zinc-700 transition-all duration-300" />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
